import Icon from 'components/Icon/Icon';
import styled from '@emotion/styled';

const EditIcon = styled(Icon)({
  fontSize: '1.6rem',
});

export default EditIcon;
